/**
 * authFetch — centrale wrapper voor API-calls vanuit nieuwe code.
 *
 * Gebruik in plaats van `fetch(url, { headers: hdrs() })`:
 *   const res = await authFetch(`${API}/gebruikers`);
 *   const res = await authFetch(url, { method: 'POST', body: JSON.stringify(...) });
 *
 * Features:
 *  - Voegt automatisch `Authorization: Bearer <token>` toe uit de tokenStore
 *  - Zet `cache: 'no-store'` default om iOS Safari's HTTP-cache te omzeilen
 *    (WebKit cached anders GET-responses agressief, ook met Authorization
 *    header — zorgde voor "Gebruikersbeheer 0 users" bug op echte iPhone/iPad)
 *  - Voor non-GET: zet `Content-Type: application/json` default
 *
 * Voor bestaande code is dit niet verplicht: de globale fetch + axios
 * interceptors in `index.js` forceren ook `cache: 'no-store'` op alle
 * `/api/*` requests (excl. `/api/uploads/*`). Die interceptors zijn een
 * defense-in-depth vangnet; deze helper is de officiële API voor nieuwe
 * code zodat elke callsite expliciet is over auth + cache-gedrag.
 */
import { getAccessToken } from './tokenStore';

export const authFetch = (url, opts = {}) => {
  const token = getAccessToken();
  const method = (opts.method || 'GET').toUpperCase();
  const headers = { ...(opts.headers || {}) };

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (method !== 'GET' && method !== 'HEAD' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  return fetch(url, {
    ...opts,
    headers,
    cache: opts.cache || 'no-store',
  });
};

export default authFetch;
